// extracted by mini-css-extract-plugin
export default {"alertIcon":"style_alert-icon__OhMzT"};